export const Monitoring = () => (
  <svg
    width="95"
    height="95"
    viewBox="0 0 95 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 35.875V24.25V6C1 3.2386 3.239 1 6 1H89C91.761 1 94 3.2386 94 6V89C94 91.761 91.761 94 89 94H6C3.239 94 1 91.761 1 89V47.5H18.691C19.048 47.5 19.378 47.309 19.557 47L24.006 39.293C24.421 38.575 25.479 38.645 25.796 39.411L38.571 70.309C38.927 71.169 40.161 71.12 40.447 70.234L54.768 25.804C55.073 24.856 56.425 24.888 56.685 25.849L63.907 52.573C64.025 53.01 64.421 53.312 64.873 53.312H83.205"
      stroke="#FFD9B9"
      stroke-width="2"
    />
  </svg>
);
